/**
 * Dynamically imports the JSON translation bundle for the given locale.
 *
 * The bundles live alongside this file under `src/_gt/` so Vite can resolve
 * them as modules. Returns an empty object when the locale has no bundle,
 * which lets `gt-react` fall back to the default-locale source text.
 */
export default async function loadTranslations(locale: string) {
  try {
    const translations = await import(`./_gt/${locale}.json`);
    return translations.default;
  } catch {
    console.warn(`No translations found for ${locale}`);
    return {};
  }
}
